// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 242) return "vendor.5bcca5464630915460bb.js";
	// return url for filenames based on template
	return "" + chunkId + "." + "6027f4dc6720eb2a9f6d" + ".bundle.js";
};